import get from 'lodash/get';
import React from 'react';
import { formValues } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formActions from 'actions/formActions';
import FormField from './forms/FormField';
import RadioField from './forms/RadioField';
import styles from './TicketingUrl.scss';
import evvntTicketing from 'assets/images/evvnt_ticketing.png';

const TicketingUrl = formValues({
  pricingType: 'pricing_type',
  ticketingType: 'ticketing_url_type',
  venue: 'venue',
  prices: 'prices',
})(({ pricingType, ticketingType, formErrors, venue, prices, geotixEnabled, premiumEdit }) => {
  const trimSpaces = value => {
    return value.replace(/\s/g, '');
  };

  if (pricingType === 'free') return null;

  const country = get(venue, 'country.iso_alpha2', '');
  const zipCode = get(venue, 'post_code', '');
  const badCurrency = prices && prices.some(price => price.currency && price.currency.value !== 'USD');
  const geotixDisabled = country !== 'US' || !zipCode || !zipCode.length || badCurrency || premiumEdit;
  const noTicketText = pricingType === 'tickets_in_advance' ? 'pay at' : 'register at';
  let ticketingUrlData = [
    {
      text: 'I already have a ticketing page',
      value: 'own_url',
      disabled: premiumEdit && ticketingType === 'geotix',
    }, {
      text: `No ticketing page - ${noTicketText} the door only`,
      value: 'no_url',
      disabled: premiumEdit && ticketingType === 'geotix',
    },
  ];

  if (geotixEnabled) {
    ticketingUrlData.unshift({
      text: 'Create me a ticketing page',
      value: 'geotix',
      disabled: !geotixEnabled || geotixDisabled,
    });
  }
  
  const ticketingBanner = geotixEnabled && <div className={styles.ticketingBanner}>
    <img src={evvntTicketing}/>
    <span>Let your event reach its full potential by using ticketing powered by Evvnt.
          We track your event to registration and revenue with a focus on collecting valuable customer 
          data for you to build your community.
    </span>
  </div>;

  return (
    <div>
      <FormField
        label="Ticketing Website"
        name="ticketing_url_type"
        component={RadioField}
        error={formErrors.get('ticketing_url_type')}
        data={ticketingUrlData}
        type="text"
        className="form-control"
        subtextComponent={ticketingBanner}
        required
        infoUrl="https://support.evvnt.com/hc/en-us/articles/360020923833-Tickets-What-is-a-ticketing-URL"
      />
      {ticketingType === 'own_url' &&
        <FormField
          name="pricing_url"
          label="Ticketing URL"
          component="input"
          error={formErrors.get('pricing_url')}
          className="form-control"
          placeholder="Enter the URL where tickets are available"
          type="text"
          normalize={trimSpaces}
          required
        />
      }
    </div>
  );
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(formActions, dispatch),
});

export default connect(
  null,
  mapDispatchToProps
)(TicketingUrl);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/TicketingUrl.jsx